import { Outlet } from 'react-router-dom';

const UnAuthentifiedLayout = () => (
    <>
        <Outlet />
    </>
);

export default UnAuthentifiedLayout;
